import React, { useMemo, useState } from 'react';
import { Layout } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
// import { logout } from '../../services/auth';
import { ROUTES } from '../../constants/routes';
import downloadIcon from '../../assets/download.svg';
import preferIcon from '../../assets/prefer.svg';
import questionIcon from '../../assets/question.svg';
import userIcon from '../../assets/user.svg';
import rightIcon from '../../assets/right.svg';
import collapsedIcon from '../../assets/collapsed.svg';
import fileIcon from '../../assets/file.svg';
import filetype from '../../assets/filetype.svg';
import arrowBtmIcon from '../../assets/arrowBtm.svg';


import { useUserStore, useFilesStore } from '../../stores';
import { t } from '../../locales';
import { APP_QR_CODE } from '../../constants/images';

import './index.scss'
import Vip from './components/vip';

const {  Content, Sider } = Layout;

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const [fileTypesExpanded, setFileTypesExpanded] = useState(true);
  const [showQRCode, setShowQRCode] = useState(false);
  const [showFileTypesPopover, setShowFileTypesPopover] = useState(false);
  const [showFileAllPopover, setShowFileAllPopover] = useState(false);

  const { currentUser } = useUserStore();
  const { fileTypes } = useFilesStore();

  const totalFiles = useMemo(() => {
    if (fileTypes.length) {
      return fileTypes.reduce((acc, item) => acc + item.count, 0);
    }
    return 0
  }, [fileTypes])

  return (
    <Layout style={{ minHeight: '100vh' }}>
      {/* <Header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ color: 'white', fontSize: '20px' }}>Ear Dance</div>
        <Menu theme="dark" mode="horizontal" style={{ flex: 1, justifyContent: 'flex-end' }}>
          <Menu.Item key="logout" icon={<LogoutOutlined />} onClick={handleLogout}>
            退出登录
          </Menu.Item>
        </Menu>
      </Header> */}
      <Layout>
        <Sider 
          width={253} 
          collapsible
          collapsed={collapsed} 
          onCollapse={(value) => setCollapsed(value)}
          theme="light"
          trigger={null}
          collapsedWidth={64}
        >
          {/* <Menu
            mode="inline"
            selectedKeys={[location.pathname]}
            style={{ height: '100%', borderRight: 0 }}
            items={menuItems}
            onClick={({ key }) => navigate(key)}
          /> */}
          <div className={`main-nav-container ${collapsed ? 'small-nav-hide' : ''}`}>
            <div className='main-nav-top'>
              <div className='main-logo'>
                <div className={`main-logo-info ${collapsed ? 'hidden' : ''}`}>AILITH</div>
                <div className='collapse-icon'>
                  <img src={collapsedIcon} alt="" onClick={() => setCollapsed(!collapsed)} />
                </div>
              </div>
              <div className='main-file-list'>
                <div
                  className={`main-file-all ${location.pathname === ROUTES.FILE && !location.search ? 'active' : ''}`}
                  onClick={() => navigate(ROUTES.FILE)}
                  onMouseEnter={() => setShowFileAllPopover(true)}
                  onMouseLeave={() => setShowFileAllPopover(false)}
                >
                  <div className='main-file-all-left'>
                    <img src={fileIcon} alt="" />
                    <span className={collapsed ? 'hidden' : ''}>{t('aside.allFile')}</span>
                  </div>
                  <span className={`${collapsed ? 'hidden' : ''}`}>{totalFiles}</span>
                  {
                    collapsed && showFileAllPopover && (
                      <div className='fixed-hide-all-con' onClick={() => setShowFileAllPopover(false)}>
                        <div className='fixed-hide-all-content-outer'>
                        <div className='fixed-hide-all-content'>
                          <span>{t('aside.allFile')}</span>
                          <span>{totalFiles}</span>
                        </div>
                        </div>
                      </div>
                    )
                  }
                </div>
                <div className='main-file-types'>
                  <div className='main-file-cate'>
                    <span className={collapsed ? 'hidden' : ''}>{t('aside.allTypes')}</span>
                    <img 
                      src={arrowBtmIcon} 
                      alt="" 
                      className={`${collapsed ? 'hidden' : ''} ${fileTypesExpanded ? 'expanded' : ''}`}
                      onClick={() => setFileTypesExpanded(!fileTypesExpanded)}
                    />
                  </div>
                  {
                    fileTypesExpanded && fileTypes.map((item) => (
                      <div 
                        key={item.sourceType} 
                        className={`main-file-cate-item ${location.pathname === ROUTES.FILE && location.search === `?sourceType=${item.sourceType}` ? 'active' : ''} ${collapsed ? 'hidden' : ''}`} 
                        onClick={() => navigate(`${ROUTES.FILE}?sourceType=${item.sourceType}`)}
                      >
                        <span>{item.name}</span>
                        <span>{item.count}</span>
                      </div>
                    ))
                  }
                </div>
                {
                  collapsed && (
                    <div
                      className={`main-file-types-hide ${location.pathname === ROUTES.FILE && location.search ? 'active' : ''}`}
                      onMouseEnter={() => setShowFileTypesPopover(true)}
                      onMouseLeave={() => setShowFileTypesPopover(false)}
                    >
                      <img src={filetype} alt="" />
                      {
                        showFileTypesPopover && (
                          <div className='fixed-hide-types-con'>
                            <div className='fixed-hide-types-content-outer'>
                            <div className='fixed-hide-types-content'>
                              {
                                fileTypes.map((item) => (
                                  <div 
                                    key={item.sourceType} 
                                    className={`${location.pathname === ROUTES.FILE && location.search === `?sourceType=${item.sourceType}` ? 'active' : ''}`} 
                                    onClick={() => { navigate(`${ROUTES.FILE}?sourceType=${item.sourceType}`); setShowFileTypesPopover(false) }}
                                  >
                                    <span>{item.name}</span>
                                    <span>{item.count}</span>
                                  </div>
                                ))
                              }
                            </div>
                            </div>
                          </div>
                        )
                      }
                    </div>
                  )
                }
              </div>
            </div>
            <div className='main-nav-btm'>
              <div className={`main-nav-item ${location.pathname === ROUTES.PROFILE ? 'active' : ''}`} onClick={() => navigate(ROUTES.PROFILE)}>
                <div className='main-item-icon'>
                  <img src={preferIcon} alt="" />
                </div>
                <div className={`main-item-text ${collapsed ? 'hidden' : ''}`}>{t('aside.setting')}</div>
              </div>
              <div 
                className='main-nav-item'
                onMouseEnter={() => setShowQRCode(true)}
                onMouseLeave={() => setShowQRCode(false)}
              >
                <div className='main-item-icon'>
                  <img src={downloadIcon} alt="" />
                </div>
                <div className={`main-item-text ${collapsed ? 'hidden' : ''}`}>{t('common.download')}</div>
                {showQRCode && (
                  <div className='qr-code-popup'>
                    <div className='qr-code-content'>
                      <div className='qr-code-image'>
                        {/* 这里可以放置实际的二维码图片 */}
                        <img src={APP_QR_CODE} alt="" className='qr-code-placeholder' />
                      </div>
                      <div className='qr-code-tip'>{t('aside.scanCode')}</div>
                    </div>
                  </div>
                )}
              </div>
              <div className={`main-nav-item ${location.pathname === ROUTES.FEEDBACK ? 'active' : ''}`} onClick={() => navigate(ROUTES.FEEDBACK)}>
                <div className='main-item-icon'>
                  <img src={questionIcon} alt="" />
                </div>
                <div className={`main-item-text ${collapsed ? 'hidden' : ''}`}>{t('aside.helpFeed')}</div>
              </div>
              {/* {
                !collapsed && (
                  <Vip />
                )
              } */}
              <div className={`main-user-entry`} onClick={() => navigate(ROUTES.PROFILE)}>
                <div className='main-user'>
                  <div className='main-user-avatar'>
                    <img src={userIcon} alt="" />
                  </div>
                  <div className={`main-user-name ${collapsed ? 'hidden' : ''}`}>{currentUser?.email}</div>
                </div>
                <img src={rightIcon} alt="" className={`main-user-right-icon ${collapsed ? 'hidden' : ''}`} />
              </div>
            </div>
          </div>
        </Sider>
        <Layout style={{ }}>
          <Content
            style={{
              margin: 0,
              minHeight: '100%',
              background: '#fff',
            }}
          >
            {children}
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default MainLayout; 